import styled, { css } from 'styled-components';

// CONSTANTS
import { responsiveEndPoints } from '../../constants/responsive-endpoints';
import { theme } from '../../constants/theme';

// INTERFACES
import { IHeader } from '../../interfaces/Header.interface';

export const Container = styled.div<IHeader>`
  display: flex;
  justify-content: space-between;
  min-height: 80px;
  z-index: 10000;
  box-sizing: border-box;
  box-shadow: 0px 1px 1px rgba(0, 0, 0, 0.03);
  font-family: 'Clan Pro';
  font-weight: ${theme.weights.semibold};
  font-size: 12.6px;
  color: ${theme.colors.primary.black};
  background: ${theme.colors.primary.white};
   ${({ fixedPosition }) =>
     fixedPosition &&
     css`
       position: fixed;
       margin-left: 300px;
       width: calc(100% - 300px);
     `}

  @media (max-width: ${responsiveEndPoints.responsive}px) {
    margin-left: 100px;
    width: calc(100% - 100px);
    min-height: 60px;
  }
`;

export const Children = styled.div`
  padding: 24px 60px 24px 107px;
  @media (max-width: ${responsiveEndPoints.responsive}px) {
    padding: 24px 60px 24px 30px;
  }
`;

export const User = styled.div`
  display: flex;
  align-items: center;
  padding-right: 50px;
  > span {
    padding-right: 20px;
  }
`;
